import React from 'react';

import Panel from '@components/smartAdminUI/Panel';
import SpinWidget from '@components/widget/SpinWidget';

const Spin = () => (
  <>
    <div className="subheader">
      <h1 className="subheader-title">
        <i className="subheader-icon fal fa-search-location mr-2" />
        Spin2
      </h1>
    </div>
    <div className="row">
      <div className="col-lg-4 d-flex">
        <Panel customClass="w-100">
          <SpinWidget />
        </Panel>
      </div>
    </div>
  </>
);

export default Spin;
